// extracted by mini-css-extract-plugin
module.exports = {"normal":"Index_normal__SXq1i","normalh5":"Index_normalh5__EwwTX","animationFade":"Index_animationFade__3wUFn"};